import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconRegisterOptions } from '../../models/icon-register';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);

  registerIcon(iconName: string, url: string): void {
    this.matIconRegistry.addSvgIcon(
      iconName,
      this.domSanitizer.bypassSecurityTrustResourceUrl(url)
    );
  }

  registerIcons(iconRegisterList: IconRegisterOptions[]): void {
    iconRegisterList.forEach((icon: IconRegisterOptions) => {
      this.registerIcon(icon.iconName, icon.url);
    });
  }
}
